module.exports = __webpack_public_path__ + "img/202502_06.821d8db6.jpg";